import { useContext } from 'react';
import PortfolioItemContext from '../../../PortfolioItemContext';
import FieldContext from '../FieldContext';
import CoachCommentsContext from '../CoachComments/CoachCommentsContext';
import CoachComments from '../CoachComments';

const FieldCoachComments = () => {
  const { portfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);
  const field = useContext(FieldContext);

  return (
    <CoachCommentsContext.Provider
      value={{
        coachComments: Object.values(portfolioItem.coachComments).filter(
          coachComment => coachComment.fieldId === field.id,
        ),
        addCoachCommentApiUrl: `${portfolioItemApiEndpoint}/coach-comments?fieldId=${field.id}`,
        isInLogEntry: false,
      }}
    >
      <CoachComments />
    </CoachCommentsContext.Provider>
  );
};

export default FieldCoachComments;
